import React from "react";
import { partners } from "../mock";
import ContactForm from "../components/heider/ContactForm";
import Footer from "../components/heider/Footer";
import useReveal from "../hooks/useReveal";

const PartnerCard = ({ p, i }) => (
  <div data-testid={`partner-${p.slug}`} className={`grid grid-cols-1 gap-8 md:gap-14 items-center reveal ${i % 2 ? "md:grid-cols-[1fr_320px]" : "md:grid-cols-[320px_1fr]"}`}>
    <div className={`overflow-hidden aspect-[4/5] bg-neutral-200 max-w-[320px] ${i % 2 ? "md:order-2" : ""}`}>
      <img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover object-top transition-transform duration-[1400ms] hover:scale-105" />
    </div>
    <div>
      <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-3">{p.tag}</p>
      <h2 className="font-serif-display text-4xl md:text-5xl font-light text-[#1a1a1a] mb-2">{p.name}</h2>
      <p className="text-[12px] tracking-luxe-sm uppercase text-neutral-500 mb-6">{p.title}</p>
      <p className="text-neutral-600 text-[15px] leading-relaxed max-w-2xl">{p.bio}</p>
    </div>
  </div>
);

const PartnersPage = () => {
  useReveal();
  return (
    <div className="page-in">
      <section className="bg-[#0d0d0d] text-white pt-40 pb-20 md:pt-48 md:pb-24">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">Trusted Partners</p>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light" data-testid="partners-title">Meet Our Partners</h1>
          <p className="text-white/55 text-[15px] leading-relaxed max-w-2xl mt-6">The lenders and title experts we trust to take our clients from pre-approval to the closing table &mdash; smoothly and on time.</p>
        </div>
      </section>
      <section className="bg-[#f3f1ec] py-24 md:py-32">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 space-y-20 md:space-y-28">
          {partners.map((p, i) => <PartnerCard key={p.slug} p={p} i={i} />)}
        </div>
      </section>
      <ContactForm source="Partners Page" />
      <Footer />
    </div>
  );
};

export default PartnersPage;
